module.exports = __webpack_public_path__ + "static/media/16.ad24b4e3.mp3";